import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-screen min-h-[600px] max-h-[900px] overflow-hidden rounded-2xl md:rounded-3xl mx-0 md:mx-4 mt-0 md:mt-4">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Fresh%20modern%20sneakers%20display%20with%20vibrant%20color%20block%20athletic%20shoes%20arranged%20on%20white%20marble%20countertop%2C%20soft%20natural%20daylight%20from%20side%20window%20casting%20gentle%20highlights%2C%20pastel%20peach%20and%20sage%20green%20accessories%20accents%2C%20minimalist%20editorial%20product%20composition%2C%20lifestyle%20sneaker%20photography%20with%20crisp%20shadows%2C%20polished%20white%20aesthetic%20with%20subtle%20reflective%20surfaces%2C%20contemporary%20boutique%20atmosphere%2C%20no%20people%20visible&width=1600&height=900&seq=hero-bg-v2-2026&orientation=landscape"
        alt="Superbuy Spreadsheet - Product Discovery and Shopping Guide"
        title="Superbuy Spreadsheet 2026 Ultimate Shopping Guide"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs md:text-sm font-medium mb-6 tracking-wide">
          Updated Weekly
        </span>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-semibold text-background-50 leading-tight max-w-4xl">
          Superbuy Spreadsheet
        </h1>
        <p className="font-heading text-2xl md:text-3xl lg:text-4xl text-background-50/90 mt-3 mb-4 font-normal">
          The Ultimate Product Discovery Hub
        </p>
        <p className="text-sm md:text-base text-background-50/75 max-w-xl leading-relaxed">
          Discover thousands of organized finds. Compare categories and shop smarter globally.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <button
            onClick={() => {
              const el = document.getElementById('categories');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-7 py-3 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Explore Categories
          </button>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 rounded-full border border-background-50/50 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line ml-1.5 text-sm"></i>
          </a>
        </div>

        {/* Article CTA */}
        <div className="mt-10">
          <button
            onClick={() => navigate('/superbuy-spreadsheet-guide')}
            className="group flex items-center gap-2 text-background-50/80 hover:text-background-50 transition-colors cursor-pointer"
          >
            <span className="text-sm font-medium underline underline-offset-4 decoration-background-50/30 group-hover:decoration-background-50/60">
              Read the Complete Superbuy Spreadsheet Guide
            </span>
            <i className="ri-arrow-right-line text-sm group-hover:translate-x-0.5 transition-transform"></i>
          </button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
          <div className="w-6 h-10 rounded-full border-2 border-background-50/40 flex items-start justify-center pt-2">
            <div className="w-1 h-2.5 rounded-full bg-background-50/60 animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}